import React from 'react';
import styled from 'styled-components';

const Message = styled.div`
	padding: 20px 5%;
	text-align: center;
`;

const ErrorDetail = styled.p`
	margin-top: 50px;
	color: #666;
`;

const ErrorMessage = ({ children }) => {
	return (
		<Message>
			<h4>Sorry, we had an issue loading this page</h4>
			<p>If you think this is a problem on our end, let us know and we will try to fix it.</p>
			<ErrorDetail>{children}</ErrorDetail>
		</Message>
	);
};

export default ErrorMessage;
